import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import dataService from "@/app/services/dataService";
import OrderDetailsSectionsLayout from "./OrderDetailsSectionsLayout";
import { useGlobalNotification } from "../header/GlobalNotificationContext";
import { ERROR_MESSAGE } from "@/app/constants/constants";
import { NotificationTypeEnum } from "@/enums/notificationTypeEnum";
import { isSAPSource } from "@/app/utils/erpHelper";

const OrderDetailsData = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setNotification } = useGlobalNotification();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["orderDetails", id],
    queryFn: async () => {
      const result = await dataService.getOrderDetailsById(Number(id));

      if (result.success) {
        return result.data;
      } else {
        setNotification(ERROR_MESSAGE, NotificationTypeEnum.ERROR);
      }
    },
    gcTime: 0,
  });

  const {
    data: DQdata,
    isLoading: DQIsLoading,
    isError: DQIsError,
  } = useQuery({
    queryKey: ["dq-orderDetails", id],
    queryFn: async () => {
      const result = await dataService.getDQDeliveryOrderById(Number(id));

      if (result.success) {
        return result.data;
      } else {
        setNotification(ERROR_MESSAGE, NotificationTypeEnum.ERROR);
      }
    },
    staleTime: 0,
    gcTime: 0,
  });

  const isSAPOrder = isSAPSource(data?.source ?? "");

  if (isError || DQIsError) {
    setNotification(ERROR_MESSAGE, NotificationTypeEnum.ERROR);
    navigate("/");

    return <></>;
  }

  return (
    <OrderDetailsSectionsLayout
      isOrderLoading={isLoading}
      order={data}
      isDQLoading={DQIsLoading}
      dqData={DQdata}
      isSAPOrder={isSAPOrder}
    />
  );
};

export default OrderDetailsData;
